import { Form, Input } from "decorator-form";

import InputType from "common/form/InputType";

@Form({ title: "Playlist Panel Config" })
export default class PlaylistCofigPanel {
	@Input({ type: InputType.TEXT, title: "Query Paramter" })
	public paramName: string;

	@Input({ type: InputType.JSON, title: "Playlist Params" })
	public playlistParams: object;

	@Input({type: InputType.NUMBER, title: "Page Size"})
	public pageSize?: number;
}



// WEBPACK FOOTER //
// ./src/panels/favorites/PlaylistTablePanelConfig.ts